<template>
  <div class="pa-3">
    <v-row>
      <template v-for="sector in model.mapping?.sectors?.filter(s => s.active).sort((a, b) => a.order - b.order)" :key="sector.id">
        <v-col v-for="section in sector.sections.filter(s => s.active)" :key="section.id" cols="12">
          <v-card elevation="3">
            <template #title>
              <span>{{ sector.name }}</span>
            </template>
            <template #subtitle>
              <span>{{ section.name }}</span>
            </template>
            <template #append>
              <v-btn
                v-if="hasFields(section)"
                color="primary"
                :loading="loader.loading"
                :disabled="loader.loading"
                @click="sectionOnSorting = section"
              >
                Ordenar Campos
              </v-btn>
            </template>

            <v-card-text>
              <v-row>
                <v-col>
                  <v-table>
                    <thead v-if="hasFields(section)">
                      <tr>
                        <th>Tipo de Ingresso</th>
                        <th>Tipo de Campo</th>
                        <th>Nome do Campo</th>
                        <th>Obrigatório</th>
                        <th>Máscara</th>
                        <th>Opções</th>
                        <th class="text-end">
                          Ações
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <template v-for="type in section.ticket_types" :key="type.id">
                        <tr v-for="field in type.additional_fields?.sort((a, b) => a.order - b.order)" :key="field.id">
                          <td>{{ type.name }}</td>
                          <td>{{ fieldType(field) }}</td>
                          <td>{{ field.label }}</td>
                          <td>{{ field.required ? 'Sim' : 'Não' }}</td>
                          <td>{{ field.mask }}</td>
                          <td>{{ field.options?.map(o => o.value).join(', ') ?? '' }}</td>
                          <td class="text-end">
                            <v-btn
                              icon
                              :disabled="loader.loading"
                              density="compact"
                              min-height="32"
                              min-width="32"
                              elevation="1"
                              class="mr-2 pa-2"
                              @click="openForm(type, field)"
                            >
                              <v-icon color="blue" icon="fa-solid fa-pen" size="x-small" />
                            </v-btn>
                            <v-btn
                              icon
                              :disabled="loader.loading"
                              density="compact"
                              min-height="32"
                              min-width="32"
                              elevation="1"
                              class="mr-2 pa-2"
                              @click="destroy(field)"
                            >
                              <v-icon color="error" icon="fa-solid fa-trash" size="x-small" />
                            </v-btn>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </v-table>
                </v-col>
              </v-row>
              <v-row v-if="copy && section.ticket_types?.find(t => t.id === copy?.ticket_type_id)">
                <v-col cols="12" sm="6" md="4">
                  <v-select
                    v-model="copy.ticket_type_id"
                    label="Tipo de Ingresso"
                    :items="types.filter(t => t?.section_id === section.id)"
                    item-title="name"
                    item-value="id"
                    hide-details
                    variant="outlined"
                    density="compact"
                    color="orange lighten-2"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="3">
                  <v-select
                    v-model="copy.type"
                    label="Tipo de Campo"
                    :items="[
                      { title: 'Texto', value: 'text' },
                      { title: 'Data', value: 'timestamp' },
                      { title: 'Seletor', value: 'select' },
                    ]"
                    hide-details
                    variant="outlined"
                    density="compact"
                    color="orange lighten-2"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="3">
                  <v-text-field
                    v-model="copy.label"
                    label="Nome do Campo"
                    hide-details
                    :rules="[v => !!v.trim() || 'O nome do campo é obrigatório']"
                    :disabled="loader.loading"
                    variant="outlined"
                    density="compact"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <v-checkbox
                    v-model="copy.required"
                    label="Obrigatório"
                    hide-details
                    variant="outlined"
                    density="compact"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="4"
                  class="d-flex align-center ga-2"
                >
                  <v-text-field
                    v-model="copy.placeholder"
                    label="Placeholder"
                    hide-details
                    :rules="[]"
                    :readonly="false"
                    :disabled="loader.loading"
                    variant="outlined"
                    density="compact"
                  />
                  <t-tooltip location="top">
                    <div># -> Número (0-9)</div>
                    <div>A -> Letra (a-z ou A-Z)</div>
                    <div>B -> Número ou letra</div>
                    <div>X -> Qualquer caractere</div>
                    <div>? -> Próximo caractere é opcional</div>
                    <br>
                    <div>Exemplos:</div>
                    <div>###.###.###-### -> CPF</div>
                    <div>(##) ####-#### -> Telefone Fixo</div>
                    <div>(##) #####-#### -> Celular</div>
                    <div>AA-### -> Código com letras e números</div>
                    <div>#####? -> Até 5 dígitos, sendo o último opcional</div>
                  </t-tooltip>
                </v-col>
                <v-col
                  v-if="copy.type === 'text'"
                  cols="12"
                  sm="6"
                  md="4"
                >
                  <v-text-field
                    v-model="copy.mask"
                    label="Máscara"
                    hide-details
                    variant="outlined"
                    density="compact"
                  />
                </v-col>
                <v-col
                  v-if="copy.type === 'select'"
                  cols="12"
                  sm="6"
                  md="4"
                >
                  <v-combobox
                    v-model="copy.options"
                    label="Opções"
                    :rules="[v => (v && v.length > 0) || 'Adicione ao menos uma opção']"
                    :delimiters="[',', ';']"
                    validate-on="eager"
                    hide-details
                    item-title="value"
                    chips
                    multiple
                    variant="outlined"
                    density="compact"
                  />
                </v-col>
                <v-col cols="12">
                  <v-row justify="end">
                    <v-col cols="12" sm="6" md="2">
                      <v-btn
                        type="submit"
                        color="primary"
                        class="w-100"
                        :loading="loader.loading"
                        :disabled="loader.loading"
                        @click="closeForm"
                      >
                        Cancelar
                      </v-btn>
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                      <v-btn
                        color="primary"
                        class="w-100"
                        :loading="loader.loading"
                        :disabled="loader.loading"
                        @click="saveChanges"
                      >
                        Salvar
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <v-row v-if="!copy || !section.ticket_types?.find(t => t.id === copy?.ticket_type_id)" justify="center" class="my-1">
                <v-btn
                  icon="fa-solid fa-plus"
                  color="primary"
                  size="x-small"
                  :loading="loader.loading"
                  :disabled="loader.loading"
                  @click="openForm(section.ticket_types![0])"
                />
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </template>
    </v-row>

    <dialog-additional-fields-sorting
      v-if="sectionOnSorting"
      v-model:section="sectionOnSorting"
      @close="sectionOnSorting = undefined"
    />
  </div>
</template>

<script lang="ts" setup>
import AdditionalFieldService from '@/services/AdditionalFieldService'
import { useDialog } from '@/stores/dialog'
import { useLoader } from '@/stores/loader'
import { useSnackBar } from '@/stores/snackbar'
import AdditionalField, { AdditionalFieldOption } from '@/types/AdditionalField'
import EventConfiguration from '@/types/EventConfiguration'
import TicketType from '@/types/TicketType'
import { computed, ref } from 'vue'
import TTooltip from '@/components/TTooltip.vue'
import DialogAdditionalFieldsSorting from './dialog-additional-fields-sorting.vue'
import Section from '@/types/Section'

const loader = useLoader()
const snackbar = useSnackBar()
const dialog = useDialog()

const service = new AdditionalFieldService()

const model = defineModel<EventConfiguration>({ required: true })

defineProps<{ editing?: boolean }>()

const copy = ref<AdditionalField>()

const original = ref<AdditionalField>()

const types = computed(() => (model.value.mapping?.sectors ?? []).flatMap(s => s.sections).flatMap(s => s.ticket_types ?? []))

function fieldType(field: AdditionalField) {
  if (field.type === 'text') return 'Texto'
  if (field.type === 'select') return 'Seletor'
  if (field.type === 'timestamp') return 'Data'
  return ''
}

function hasFields(section: Section) {
  return section.ticket_types?.some(t => (t.additional_fields?.length ?? 0) > 0)
}

function openForm(_type: TicketType, field?: AdditionalField) {
  const targetField = field
    ? { ...field }
    : {
        id: '',
        type: 'text',
        label: '',
        placeholder: '',
        required: false,
        mask: null,
        options: [],
        ticket_type_id: _type.id,
      } as unknown as AdditionalField

  copy.value = targetField
  original.value = field
}

function closeForm() {
  copy.value = undefined
  original.value = undefined
}

async function saveChanges() {
  if (!copy.value) return

  if (copy.value.id) {
    const confirm = await dialog.open({
      title: 'Confirmação de edição',
      message: 'Realmente deseja editar este campo adicional?',
    })

    if (!confirm) return
  }

  if (copy.value.options && copy.value.options.length > 0) {
    // Map combobox returned strings to AdditionalFieldOption
    // This sucks, but I blame VCombobox API
    copy.value.options = copy.value.options.map((o) => {
      if (typeof o === 'string') {
        return { value: (o as string).trim() } as unknown as AdditionalFieldOption
      }
      return o
    }) ?? []

    // Remove empty strings
    copy.value.options = copy.value.options.filter(o => o.value && o.value.length > 0)
  }

  if (!validate()) {
    snackbar.show('Preencha todos os campos obrigatórios.', 'error')
    return
  }

  // We cant upsert the field if the type doesn't exist yet
  const success = await upsert(copy.value)

  if (!success) return

  // Remove the field from the old type
  if (original.value) {
    const found = types.value.find(t => t.id === original.value!.ticket_type_id)
    if (found) {
      found.additional_fields = found.additional_fields?.filter(f => f !== original.value) ?? []
    }
  }

  // Add the field to the new type
  const found = types.value.find(t => t.id === copy.value!.ticket_type_id)
  if (found) {
    found.additional_fields?.push(copy.value)
  }

  closeForm()
}

async function upsert(field: AdditionalField) {
  let success = false
  try {
    loader.increment()

    // TODO: transform this into a single route
    const { data } = field.id ? await service.update(field) : await service.store(field)

    copy.value = data

    snackbar.show('Campo adicional salvo com sucesso.', 'success')

    success = true
  } catch {
    success = false
  } finally {
    loader.decrement()
  }

  return success
}

async function destroy(field: AdditionalField) {
  try {
    if (field.id) {
      const confirm = await dialog.open({
        title: 'Confirmação de exclusão',
        message: 'Realmente deseja excluir este campo adicional? Essa ação é irreversível.',
      })

      if (!confirm) return

      loader.increment()

      await service.destroy(field.id)
      snackbar.show('Campo adicional excluído com sucesso.', 'success')
    }

    // Removes the field from the listing
    types.value.forEach((t) => {
      if (!t?.additional_fields?.includes(field)) return
      t.additional_fields?.splice(t.additional_fields?.indexOf(field), 1)
    })
  } finally {
    loader.decrement()
  }
}

function validate() {
  if (!copy.value) return false

  return !!copy.value.label.trim() && (copy.value.type !== 'select' || (copy.value.options && copy.value.options.length > 0))
}

const sectionOnSorting = ref<Section>()

</script>
